module.exports = __webpack_public_path__ + "static/media/helpIcon.48058af5.svg";